// Original-SINUS-Schwunglinien ("lax-circles" von sinus-institut.de): zwei
// geschlossene Schleifen, Blau #0ea6e0 + Rot #e9473d. Pfade 1:1 aus dem
// Webauftritt übernommen (getBBox-Bounds als viewBox, ohne die dortige
// Scroll-Animation). Rein dekorativ (aria-hidden). Linienstärke via
// non-scaling-stroke konstant dünn wie im Original.

interface Props {
  className?: string
}

export function BrandSwoosh({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="1102 244 904 437"
      fill="none"
      aria-hidden="true"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M1345.99,621.811C1224.516,586.944,1048.5,459.057,1135.9,340.471c62.225-84.428,273.8,25.906,409.036-14.843,466.872-140.677,544.51,93.778,295.958,205.687C1660.816,612.39,1452.171,652.289,1345.99,621.811Z"
        stroke="#0ea6e0"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M1728.5,255.53c125.559,14.338,320.269,111.422,253.645,242.806-47.432,93.54-274.317,19.64-400.972,82.15-437.254,215.8-552.527-2.621-325.85-154.018C1419.544,316.782,1618.74,242.994,1728.5,255.53Z"
        stroke="#e9473d"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
